import { Injector, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { AuthComponent } from './auth.component';
import { RequestPasswordComponent } from './components/request-password/request-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { AuthGuardService as AuthGuard } from 'src/app/core/services/auth-guard.service';
import { GuestGuard } from 'src/app/core/services/guest.guard';
import { ValidateComponent } from './components/validate/validate.component';
import { RequestAccountRecoverComponent } from './components/request-account-recover/account-recover.component';

const routes: Routes = [
    {
        path: '',
        component: AuthComponent,
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'request-password', component: RequestPasswordComponent },
            {
                path: 'change-password',
                component: ChangePasswordComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'validate-access-code',
                component: ValidateComponent,
            },
            {
                path: 'request-account-recover',
                component: RequestAccountRecoverComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
